import { render, staticRenderFns } from "./main.vue?vue&type=template&id=260f6730&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f6730",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260f6730')) {
      api.createRecord('260f6730', component.options)
    } else {
      api.reload('260f6730', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=260f6730&scoped=true", function () {
      api.rerender('260f6730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/dashboard/employee-part-time/main.vue"
export default component.exports